import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from '../containers/ApplicationContext';
import { selectOffer } from '../selectors';
import { getDynamicCalltrackingSiteBlockId } from '../selectors/getDynamicCalltrackingSiteBlockId';
import { getIsOfferDynamicCalltrackingEnabled } from '../utils/dynamicCalltracking';

/** ДинКТ вторички (SEL-998); новостройки с siteBlockId живут на своём динКТ */
export function useOfferDynamicCalltrackingEnabled(): boolean {
  const { config } = useApplicationContext();
  const offer = useSelector(selectOffer);
  const newbuildingSiteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);

  return useMemo(
    () => !newbuildingSiteBlockId && getIsOfferDynamicCalltrackingEnabled(config, offer.geo),
    [config, newbuildingSiteBlockId, offer.geo],
  );
}
